import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './lib/i18n/i18nConfig.ts'
import App from './App.tsx'
import Contexts from './contexts/index.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Contexts>
      <App />
    </Contexts>
  </StrictMode>,
)
